
<div  class="wrapper">
    <div class="cargando-jardin"><mat-spinner *ngIf="cargando"></mat-spinner></div>
    <div *ngIf="!cargando" class="contenidoBase"> 
        
        <input type="checkbox" id="nav-toggle">
        <div class="sidebar" >
            <div class="sidebar-brand profile">
                <div class="junji-profile">
                    <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg">
                </div>
                <ng-template #popContent >
                    <button (click)="cambiarPass()" type="button" class="btn btn-light btn-popover"><i class="fas fa-key"></i> CAMBIAR CLAVE</button>
                    <button (click)="cambiarFoto()" type="button" class="btn btn-light btn-popover"><i class="fas fa-portrait"></i> CAMBIAR FOTO</button>
                    <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-popover"><i class="fas fa-power-off"></i> SALIR</button>
                </ng-template>
                <ng-template #popTitle>{{datosPP.persona.nombres}} <br> {{datosPP.persona.apellido_paterno}}</ng-template>
                <button  class="image-cropper" placement="bottom" [ngbPopover]="popContent" [popoverTitle]="popTitle">
                        <img [src]="urlProfile" alt="avatar" id="improfile" class="profile-pic" >  
                </button>
                <p class="welcomeText">Bienvenida,</p>
                <p class="userName">{{datosPP.persona.nombres}}</p>
            </div>
            <!--Secciones-del-tablero-->
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <a (click)="menuVisible('inicio')" [className]="menuMostrar==='inicio'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_inicio_off.svg" *ngIf="menuMostrar!='inicio'">
                            <img src="../../../assets/icons/JUNJI_inicio_on.svg" *ngIf="menuMostrar==='inicio'">
                            <span class="menu-text">CAPACITACIÓN</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="sidebar-brand">
                <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-logout"><i class="fas fa-power-off"></i> Salir</button>
            </div>
        </div>


        <div class="main-content">
            <header>
                <div>
                    <p class="title1">                  
                        MODELO DE GESTIÓN DE LA CALIDAD
                    </p>
                    <p class="title2">                  
                        DE LA EDUCACIÓN PARVULARIA
                    </p>
                </div>
                
                <div class="user-wrapper">
                    <div>

                        <p class="title-jardin">JARDÍN INFANTIL:</p>
                        <div class="jardin-name">
                            <p> {{jardin.jardin}}</p>
                        </div>
                        
                      
                    </div>
                </div>
            </header>
    
            <main>
                <app-capacitacion-jardin *ngIf="menuMostrar==='inicio'"></app-capacitacion-jardin>  
            </main>
    
        </div>



    <div> 
</div>
